export default __webpack_public_path__ + "static/media/TERMINOS-DE-USO-DEL-PRODUCTO-Y-DEL-SITIO-WEB-CONTROL-B.17c64fb4.pdf";